// import React, { useEffect, useMemo, useRef, useState } from "react";
// import { get, post, put } from "../../../lib/http";
// import { API } from "../../../config/api";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";

// /* ----------------------- small helpers ----------------------- */
// const cn = (...a) => a.filter(Boolean).join(" ");
// const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
// const MAX_IMG_MB = 5;

// export default function AddEditBanner() {
//   const { id } = useParams();
//   const navigate = useNavigate();

//   const isEdit = Boolean(id);
//   const [loading, setLoading] = useState(true);
//   const [saving, setSaving] = useState(false);
//   const [uploading, setUploading] = useState(false);
//   const [events, setEvents] = useState([]);
//   const [eventsLoading, setEventsLoading] = useState(true);


//   const [formData, setFormData] = useState({
//     title: "",
//     imageUrl: "",
//     type: "homepage",
//     eventId: "",
//     isActive: true,
//   });

//   const needsEvent = useMemo(() => formData.type === "homepage", [formData.type]);
//   const fileInputRef = useRef(null);

//   /* fetch events */
//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       try {
//         setEventsLoading(true);
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(API.events.getEvent, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (alive && Array.isArray(res?.events)) setEvents(res.events);
//       } catch (err) {
//         console.error("getAllEvents error:", err);
//         toast.error("Couldn’t load events.");
//       } finally {
//         if (alive) setEventsLoading(false);
//       }
//     })();
//     return () => { alive = false; };
//   }, []);

//   /* fetch banner when editing */
//   useEffect(() => {
//     let alive = true;
//     (async () => {
//       if (!isEdit) { setLoading(false); return; }
//       try {
//         const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//         const res = await get(`${API.banner.getOne}/${id}`, {
//           headers: {
//             Authorization: token ? `Bearer ${token}` : undefined,
//             "Content-Type": "application/json",
//           },
//         });
//         if (!alive) return;
//         if (res) {
//           setFormData({
//             title: res.title || "",
//             imageUrl: res.imageUrl || "",
//             type: res.type || "homepage",
//             eventId: res?.eventId?._id || "",
//             isActive: Boolean(res.isActive),
//           });
//         }
//       } catch (err) {
//         console.error("Error fetching banner:", err);
//         toast.error("Failed to fetch banner details.");
//       } finally {
//         if (alive) setLoading(false);
//       }
//     })();
//     return () => { alive = false; };
//   }, [id, isEdit]);

//   /* ✅ this hook MUST be above any early returns */
//   const selectedEventName = useMemo(
//     () => events.find((e) => e._id === formData.eventId)?.name || "",
//     [events, formData.eventId]
//   );

//   const onChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((s) => ({
//       ...s,
//       [name]: type === "checkbox" ? checked : value,
//       ...(name === "type" && value !== "event" ? { eventId: "" } : null),
//     }));
//   };

//   const validateBeforeSave = () => {
//     if (!formData.title.trim()) { toast.warn("Please enter a title."); return false; }
//     if (!formData.imageUrl) { toast.warn("Please upload a banner image."); return false; }
//     if (needsEvent && !formData.eventId) { toast.warn("Please select an event."); return false; }
//     return true;
//     };

//   const onSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateBeforeSave()) return;
//     try {
//       setSaving(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const payload = {
//         title: formData.title.trim(),
//         imageUrl: formData.imageUrl,
//         type: formData.type,
//         eventId: needsEvent ? formData.eventId : undefined,
//         isActive: !!formData.isActive,
//       };
//       if (isEdit) {
//         await put(`${API.banner.update}/${id}`, payload, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
//         });
//         toast.success("Banner updated successfully ✅");
//       } else {
//         await post(API.banner.create, payload, {
//           headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
//         });
//         toast.success("Banner created successfully ✅");
//       }
//       navigate("/admin/banners");
//     } catch (err) {
//       console.error("Error saving banner:", err);
//       toast.error("Failed to save banner ❌");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const onPickFile = () => fileInputRef.current?.click();

//   const handleDroppedFiles = async (files) => {
//     const file = files?.[0];
//     if (!file) return;
//     if (!ACCEPTED_IMG.includes(file.type)) { toast.warn("Please upload a JPG, PNG, or WEBP image."); return; }
//     if (file.size > MAX_IMG_MB * 1024 * 1024) { toast.warn(`Image must be under ${MAX_IMG_MB} MB.`); return; }

//     try {
//       setUploading(true);
//       const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
//       const fd = new FormData();
//       fd.append("file", file);
//       const res = await post(API.events.fileUploader, fd, {
//         headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "multipart/form-data" },
//       });
//       const url = res?.url;
//       if (!url) { toast.error("Upload failed. No URL returned."); return; }
//       setFormData((s) => ({ ...s, imageUrl: url }));
//       toast.success("Image uploaded ✅");
//     } catch (err) {
//       console.error("Image upload failed:", err);
//       toast.error("Image upload failed ❌");
//     } finally {
//       setUploading(false);
//     }
//   };

//   const onFileChange = (e) => handleDroppedFiles(e.target.files);

//   /* early return after ALL hooks are declared */
//   if (loading) {
//     return (
//       <div className="max-w-4xl mx-auto p-6">
//         <div className="h-7 w-48 bg-slate-200 rounded mb-4 animate-pulse" />
//         <div className="rounded-2xl bg-white p-6 shadow-sm border">
//           <div className="grid gap-4 md:grid-cols-2">
//             {Array.from({ length: 6 }).map((_, i) => (
//               <div key={i} className="h-12 bg-slate-100 rounded animate-pulse" />
//             ))}
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="max-w-4xl mx-auto p-6 space-y-6">
//       <div className="flex items-center justify-between">
//         <div>
//           <h2 className="text-2xl font-extrabold text-slate-900">
//             {isEdit ? "Edit Banner" : "Add New Banner"}
//           </h2>
//           <p className="text-sm text-slate-600">
//             Upload a striking image and attach it to an event or section.
//           </p>
//         </div>
//         <button
//           onClick={() => navigate(-1)}
//           className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50"
//         >
//           ← Back
//         </button>
//       </div>

//       <form onSubmit={onSubmit} className="rounded-2xl bg-white/90 backdrop-blur shadow-sm border p-6 space-y-6">
//         <div>
//           <label className="block text-sm font-semibold text-slate-700">
//             Title <span className="text-rose-500">*</span>
//           </label>
//           <input
//             type="text"
//             name="title"
//             value={formData.title}
//             onChange={onChange}
//             placeholder="Summer EDM Festival"
//             className="mt-1 w-full rounded-xl border px-4 py-2.5 focus:ring-2 focus:ring-amber-300"
//             required
//           />
//           <p className="text-xs text-slate-500 mt-1">Keep it short and catchy.</p>
//         </div>

//         <div>
//           <label className="block text-sm font-semibold text-slate-700">
//             Banner Image <span className="text-rose-500">*</span>
//           </label>

//           <div
//             className={cn(
//               "mt-1 rounded-2xl border-2 border-dashed p-4 md:p-6 transition bg-slate-50/60",
//               "hover:border-amber-300 hover:bg-amber-50/40"
//             )}
//             onDragOver={(e) => e.preventDefault()}
//             onDrop={(e) => {
//               e.preventDefault();
//               handleDroppedFiles(e.dataTransfer.files);
//             }}
//           >
//             {formData.imageUrl ? (
//               <div className="flex items-center gap-4">
//                 <img
//                   src={formData.imageUrl}
//                   alt="Banner preview"
//                   className="h-28 w-48 rounded-xl object-cover border"
//                 />
//                 <div className="space-y-2">
//                   <div className="text-sm text-slate-700">{formData.title || "Banner image"}</div>
//                   <div className="text-xs text-slate-500">
//                     Recommended: 1600×600 (JPG/PNG/WEBP, &lt; {MAX_IMG_MB}MB)
//                   </div>
//                   <div className="flex items-center gap-2">
//                     <button
//                       type="button"
//                       onClick={() => fileInputRef.current?.click()}
//                       disabled={uploading}
//                       className="rounded-full bg-amber-500 text-slate-900 px-4 py-2 text-sm font-semibold hover:bg-amber-400 disabled:opacity-60"
//                     >
//                       {uploading ? "Uploading…" : "Replace Image"}
//                     </button>
//                     {formData.imageUrl && (
//                       <button
//                         type="button"
//                         onClick={() => setFormData((s) => ({ ...s, imageUrl: "" }))}
//                         className="rounded-full border px-4 py-2 text-sm font-semibold hover:bg-slate-50"
//                       >
//                         Remove
//                       </button>
//                     )}
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div className="text-center py-8">
//                 <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-100 text-amber-700 grid place-items-center text-2xl">
//                   ↑
//                 </div>
//                 <div className="mt-3 font-semibold text-slate-800">Drag & drop image here</div>
//                 <div className="text-sm text-slate-500">
//                   or{" "}
//                   <button
//                     type="button"
//                     onClick={() => fileInputRef.current?.click()}
//                     className="underline underline-offset-4 text-amber-700 font-semibold"
//                   >
//                     browse to upload
//                   </button>
//                 </div>
//                 <div className="text-xs text-slate-400 mt-2">JPG, PNG, WEBP • Max {MAX_IMG_MB}MB</div>
//               </div>
//             )}

//             <input
//               ref={fileInputRef}
//               type="file"
//               accept={ACCEPTED_IMG.join(",")}
//               className="hidden"
//               onChange={onFileChange}
//             />
//           </div>
//         </div>

//         <div className="grid gap-4 md:grid-cols-2">
//           <div>
//             <label className="block text-sm font-semibold text-slate-700">Banner Type</label>
//             <div className="relative mt-1">
//               <select
//                 name="type"
//                 value={formData.type}
//                 onChange={onChange}
//                 className="w-full appearance-none rounded-xl border px-4 py-2.5 pr-9"
//               >
//                 <option value="homepage">Homepage</option>
//                 <option value="event">Event</option>
//                 <option value="sponsor">Sponsor</option>
//                 <option value="custom">Custom</option>
//               </select>
//               <svg
//                 className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//                 width="16" height="16" viewBox="0 0 24 24" fill="none"
//                 stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
//               >
//                 <path d="M6 9l6 6 6-6" />
//               </svg>
//             </div>
//             <p className="text-xs text-slate-500 mt-1">Choose where this banner will appear.</p>
//           </div>

//           <div>
//             <label className="block text-sm font-semibold text-slate-700">
//               {needsEvent ? <>Select Event <span className="text-rose-500">*</span></> : "Select Event (optional)"}
//             </label>
//             <div className="relative mt-1">
//               <select
//                 name="eventId"
//                 value={formData.eventId}
//                 onChange={onChange}
//                 disabled={!needsEvent || eventsLoading}
//                 className={cn(
//                   "w-full appearance-none rounded-xl border px-4 py-2.5 pr-9",
//                   !needsEvent && "bg-slate-50 cursor-not-allowed"
//                 )}
//                 required={needsEvent}
//               >
//                 <option value="">{eventsLoading ? "Loading…" : "-- Select Event --"}</option>
//                 {events?.map((ev) => (
//                   <option key={ev._id} value={ev._id}>{ev.name}</option>
//                 ))}
//               </select>
//               <svg
//                 className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
//                 width="16" height="16" viewBox="0 0 24 24" fill="none"
//                 stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
//               >
//                 <path d="M6 9l6 6 6-6" />
//               </svg>
//             </div>
//             {needsEvent && selectedEventName && (
//               <p className="text-xs text-slate-500 mt-1">Selected: {selectedEventName}</p>
//             )}
//           </div>
//         </div>

//         <div className="flex items-center justify-between rounded-xl border px-4 py-3">
//           <div>
//             <div className="text-sm font-semibold text-slate-800">Active</div>
//             <div className="text-xs text-slate-500">If disabled, banner won’t be visible to users.</div>
//           </div>
//           <label className="relative inline-flex items-center cursor-pointer">
//             <input
//               type="checkbox"
//               name="isActive"
//               checked={formData.isActive}
//               onChange={onChange}
//               className="sr-only peer"
//             />
//             <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
//               <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
//             </div>
//           </label>
//         </div>

//         <div className="flex items-center justify-end gap-2">
//           <button
//             type="button"
//             onClick={() => navigate("/admin/banners")}
//             className="rounded-full border px-5 py-2.5 text-sm font-semibold hover:bg-slate-50"
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             disabled={saving}
//             className={cn(
//               "rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 px-6 py-2.5 text-sm font-semibold text-slate-900 hover:from-yellow-500 hover:to-yellow-600 transition-all",
//               saving && "opacity-60 cursor-wait"
//             )}
//           >
//             {saving ? (isEdit ? "Updating…" : "Saving…") : isEdit ? "Update Banner" : "Save Banner"}
//           </button>
//         </div>
//       </form>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useRef, useState } from "react";
import { get, post, put } from "../../../lib/http";
import { API } from "../../../config/api";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { AD, focusAdminField } from "../../adminUi.js";

/* ----------------------- small helpers ----------------------- */
const cn = (...a) => a.filter(Boolean).join(" ");
const ACCEPTED_IMG = ["image/jpeg", "image/png", "image/webp"];
const MAX_IMG_MB = 5;

export default function AddEditBanner() {
  const { id } = useParams();
  const navigate = useNavigate();

  const isEdit = Boolean(id);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [uploading, setUploading] = useState(false);
  const [uploadingMobile, setUploadingMobile] = useState(false);

  const [events, setEvents] = useState([]);
  const [eventsLoading, setEventsLoading] = useState(true);

  const [formData, setFormData] = useState({
    title: "",
    imageUrl: "",
    mobileImageUrl: "", // ✅ NEW
    type: "homepage",
    eventId: "",
    isActive: true,
  });

  const needsEvent = useMemo(() => formData.type === "homepage", [formData.type]);

  const fileInputRef = useRef(null);
  const fileInputMobileRef = useRef(null); // ✅ NEW

  /* fetch events */
  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        setEventsLoading(true);
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(API.events.getEvent, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        });
        if (alive && Array.isArray(res?.events)) setEvents(res.events);
      } catch (err) {
        console.error("getAllEvents error:", err);
        toast.error("Couldn’t load events.");
      } finally {
        if (alive) setEventsLoading(false);
      }
    })();
    return () => { alive = false; };
  }, []);

  /* fetch banner when editing */
  useEffect(() => {
    let alive = true;
    (async () => {
      if (!isEdit) { setLoading(false); return; }
      try {
        const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
        const res = await get(`${API.banner.getOne}/${id}`, {
          headers: {
            Authorization: token ? `Bearer ${token}` : undefined,
            "Content-Type": "application/json",
          },
        });
        if (!alive) return;
        if (res) {
          setFormData({
            title: res.title || "",
            imageUrl: res.imageUrl || "",
            mobileImageUrl: res.mobileImageUrl || "", // ✅ NEW
            type: res.type || "homepage",
            eventId: res?.eventId?._id || "",
            isActive: Boolean(res.isActive),
          });
        }
      } catch (err) {
        console.error("Error fetching banner:", err);
        toast.error("Failed to fetch banner details.");
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => { alive = false; };
  }, [id, isEdit]);

  const selectedEventName = useMemo(
    () => events.find((e) => e._id === formData.eventId)?.name || "",
    [events, formData.eventId]
  );

  const onChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((s) => ({
      ...s,
      [name]: type === "checkbox" ? checked : value,
      ...(name === "type" && value !== "event" ? { eventId: "" } : null),
    }));
  };

  const validateBeforeSave = () => {
    const fail = (message, field) => {
      toast.warn(message);
      focusAdminField(field);
      return false;
    };
    if (!formData.title.trim()) return fail("Please enter a title.", "title");
    if (!formData.imageUrl) return fail("Please upload a desktop banner image.", "imageUrl");
    if (needsEvent && !formData.eventId) return fail("Please select an event.", "eventId");
    return true;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validateBeforeSave()) return;
    try {
      setSaving(true);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const payload = {
        title: formData.title.trim(),
        imageUrl: formData.imageUrl,
        mobileImageUrl: formData.mobileImageUrl || "", // ✅ NEW
        type: formData.type,
        eventId: needsEvent ? formData.eventId : undefined,
        isActive: !!formData.isActive,
      };
      if (isEdit) {
        await put(`${API.banner.update}/${id}`, payload, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
        });
        toast.success("Banner updated successfully ✅");
      } else {
        await post(API.banner.create, payload, {
          headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "application/json" },
        });
        toast.success("Banner created successfully ✅");
      }
      navigate("/admin/banners");
    } catch (err) {
      console.error("Error saving banner:", err);
      toast.error("Failed to save banner ❌");
    } finally {
      setSaving(false);
    }
  };

  /* ------------ uploads (desktop & mobile) ------------ */
  const handleUpload = async (file, setUrl, setBusy) => {
    if (!file) return;
    if (!ACCEPTED_IMG.includes(file.type)) { toast.warn("Please upload a JPG, PNG, or WEBP image."); return; }
    if (file.size > MAX_IMG_MB * 1024 * 1024) { toast.warn(`Image must be under ${MAX_IMG_MB} MB.`); return; }

    try {
      setBusy(true);
      const token = JSON.parse(localStorage.getItem("bb_user"))?.token;
      const fd = new FormData();
      fd.append("file", file);
      const res = await post(API.events.fileUploader, fd, {
        headers: { Authorization: token ? `Bearer ${token}` : undefined, "Content-Type": "multipart/form-data" },
      });
      const url = res?.url;
      if (!url) { toast.error("Upload failed. No URL returned."); return; }
      setUrl(url);
      toast.success("Image uploaded ✅");
    } catch (err) {
      console.error("Image upload failed:", err);
      toast.error("Image upload failed ❌");
    } finally {
      setBusy(false);
    }
  };

  const onFileChange = (e) =>
    handleUpload(e.target.files?.[0], (url) => setFormData((s) => ({ ...s, imageUrl: url })), setUploading);
  const onFileMobileChange = (e) =>
    handleUpload(e.target.files?.[0], (url) => setFormData((s) => ({ ...s, mobileImageUrl: url })), setUploadingMobile);

  const onPickFile = () => fileInputRef.current?.click();
  const onPickFileMobile = () => fileInputMobileRef.current?.click();

  /* early return after ALL hooks are declared */
  if (loading) {
    return (
      <div className={AD.formWrap}>
        <div className="mb-4 h-7 w-48 animate-pulse rounded-lg bg-slate-200 dark:bg-gray-800" />
        <div className={cn(AD.formSurface, "animate-pulse")}>
          <div className={AD.formGrid2}>
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-12 rounded-xl bg-slate-100 dark:bg-gray-800" />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={AD.formWrap}>
      <div className={AD.formHeader}>
        <div>
          <h1 className={AD.title}>{isEdit ? "Edit banner" : "Add banner"}</h1>
          <p className={AD.subtitle}>Upload a striking image and attach it to an event or section.</p>
        </div>
        <button type="button" onClick={() => navigate(-1)} className={AD.btnSecondary}>
          ← Back
        </button>
      </div>

      <form onSubmit={onSubmit} className={cn(AD.formSurface, "space-y-6")}>
        {/* Title */}
        <div>
          <label className={AD.fieldLabel}>
            Title <span className="text-rose-500">*</span>
          </label>
          <input
            type="text"
            name="title"
            data-admin-field="title"
            value={formData.title}
            onChange={onChange}
            placeholder="Summer EDM Festival"
            className={cn("mt-1", AD.inputField)}
            required
          />
          <p className={AD.fieldHint}>Keep it short and catchy.</p>
        </div>

        {/* Desktop Banner */}
        <div>
          <label className={AD.fieldLabel}>
            Banner image (desktop) <span className="text-rose-500">*</span>
          </label>

          <div
            className={cn("mt-1", AD.dropZone)}
            data-admin-field="imageUrl"
            tabIndex={-1}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              handleUpload(e.dataTransfer.files?.[0], (url) => setFormData((s) => ({ ...s, imageUrl: url })), setUploading);
            }}
          >
            {formData.imageUrl ? (
              <div className="flex items-center gap-4">
                <img
                  src={formData.imageUrl}
                  alt="Banner preview"
                  className="h-28 w-48 rounded-xl object-cover border"
                />
                <div className="space-y-2">
                  <div className="text-sm text-slate-700">{formData.title || "Banner image"}</div>
                  <div className="text-xs text-slate-500">
                    Recommended: 1600×600 (JPG/PNG/WEBP, &lt; {MAX_IMG_MB}MB)
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      onClick={onPickFile}
                      disabled={uploading}
                      className={cn(AD.btnPrimary, "py-2 text-sm disabled:opacity-60")}
                    >
                      {uploading ? "Uploading…" : "Replace image"}
                    </button>
                    <button
                      type="button"
                      onClick={() => setFormData((s) => ({ ...s, imageUrl: "" }))}
                      className={AD.btnSecondary}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-100 text-amber-700 grid place-items-center text-2xl">
                  ↑
                </div>
                <div className="mt-3 font-semibold text-slate-800">Drag & drop image here</div>
                <div className="text-sm text-slate-500">
                  or{" "}
                  <button
                    type="button"
                    onClick={onPickFile}
                    className="underline underline-offset-4 text-amber-700 font-semibold"
                  >
                    browse to upload
                  </button>
                </div>
                <div className="text-xs text-slate-400 mt-2">JPG, PNG, WEBP • Max {MAX_IMG_MB}MB</div>
              </div>
            )}
            <input
              ref={fileInputRef}
              type="file"
              accept={ACCEPTED_IMG.join(",")}
              className="hidden"
              onChange={onFileChange}
            />
          </div>
        </div>

        {/* Mobile Banner (NEW) */}
        <div>
          <label className={AD.fieldLabel}>
            Banner image (mobile) <span className="font-normal text-slate-400">(optional)</span>
          </label>

          <div
            className={cn("mt-1", AD.dropZone)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => {
              e.preventDefault();
              handleUpload(
                e.dataTransfer.files?.[0],
                (url) => setFormData((s) => ({ ...s, mobileImageUrl: url })),
                setUploadingMobile
              );
            }}
          >
            {formData.mobileImageUrl ? (
              <div className="flex items-center gap-4">
                <img
                  src={formData.mobileImageUrl}
                  alt="Mobile banner preview"
                  className="h-28 w-28 rounded-xl object-cover border"
                />
                <div className="space-y-2">
                  <div className="text-sm text-slate-700">Mobile banner image</div>
                  <div className="text-xs text-slate-500">
                    Recommended: 800×800 or 1080×1350 (≤ {MAX_IMG_MB}MB)
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      type="button"
                      onClick={() => fileInputMobileRef.current?.click()}
                      disabled={uploadingMobile}
                      className={cn(AD.btnPrimary, "py-2 text-sm disabled:opacity-60")}
                    >
                      {uploadingMobile ? "Uploading…" : "Replace image"}
                    </button>
                    <button
                      type="button"
                      onClick={() => setFormData((s) => ({ ...s, mobileImageUrl: "" }))}
                      className={AD.btnSecondary}
                    >
                      Remove
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="text-center py-8">
                <div className="mx-auto h-14 w-14 rounded-2xl bg-amber-100 text-amber-700 grid place-items-center text-2xl">
                  ↑
                </div>
                <div className="mt-3 font-semibold text-slate-800">Drag & drop image here</div>
                <div className="text-sm text-slate-500">
                  or{" "}
                  <button
                    type="button"
                    onClick={onPickFileMobile}
                    className="underline underline-offset-4 text-amber-700 font-semibold"
                  >
                    browse to upload
                  </button>
                </div>
                <div className="text-xs text-slate-400 mt-2">JPG, PNG, WEBP • Max {MAX_IMG_MB}MB</div>
              </div>
            )}
            <input
              ref={fileInputMobileRef}
              type="file"
              accept={ACCEPTED_IMG.join(",")}
              className="hidden"
              onChange={onFileMobileChange}
            />
          </div>
        </div>

        {/* Type & Event */}
        <div className={AD.formGrid2}>
          <div>
            <label className={AD.fieldLabel}>Banner type</label>
            <div className="relative mt-1">
              <select name="type" data-admin-field="type" value={formData.type} onChange={onChange} className={AD.select}>
                <option value="homepage">Homepage</option>
                <option value="event">Event</option>
                <option value="sponsor">Sponsor</option>
                <option value="custom">Custom</option>
              </select>
              <svg
                className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
            <p className={AD.fieldHint}>Choose where this banner will appear.</p>
          </div>

          <div>
            <label className={AD.fieldLabel}>
              {needsEvent ? <>Select event <span className="text-rose-500">*</span></> : "Select event (optional)"}
            </label>
            <div className="relative mt-1">
              <select
                name="eventId"
                data-admin-field="eventId"
                value={formData.eventId}
                onChange={onChange}
                disabled={!needsEvent || eventsLoading}
                className={cn(AD.select, !needsEvent && "cursor-not-allowed bg-slate-50 opacity-80 dark:bg-gray-900")}
                required={needsEvent}
              >
                <option value="">{eventsLoading ? "Loading…" : "-- Select Event --"}</option>
                {events?.map((ev) => (
                  <option key={ev._id} value={ev._id}>{ev.name}</option>
                ))}
              </select>
              <svg
                className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
                width="16" height="16" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
              >
                <path d="M6 9l6 6 6-6" />
              </svg>
            </div>
            {needsEvent && selectedEventName && (
              <p className={AD.fieldHint}>Selected: {selectedEventName}</p>
            )}
          </div>
        </div>

        {/* Active */}
        <div className={AD.toggleRow}>
          <div className="min-w-0">
            <div className="text-sm font-semibold text-slate-800 dark:text-slate-100">Active</div>
            <div className={AD.fieldHint}>If disabled, the banner will not be visible to users.</div>
          </div>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              name="isActive"
              checked={formData.isActive}
              onChange={onChange}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-slate-200 rounded-full peer-checked:bg-emerald-500 relative">
              <div className="absolute top-0.5 left-[3px] h-5 w-5 bg-white rounded-full transition-all peer-checked:translate-x-5" />
            </div>
          </label>
        </div>

        {/* Actions */}
        <div className="flex flex-wrap items-center justify-end gap-2 border-t border-slate-100 pt-4 dark:border-gray-800">
          <button type="button" onClick={() => navigate("/admin/banners")} className={AD.btnSecondary}>
            Cancel
          </button>
          <button type="submit" disabled={saving} className={cn(AD.btnPrimary, saving && "cursor-wait opacity-60")}>
            {saving ? (isEdit ? "Updating…" : "Saving…") : isEdit ? "Update banner" : "Save banner"}
          </button>
        </div>
      </form>
    </div>
  );
}
